var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookColored = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#1877F2",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M27.785 25.781 28.672 20h-5.547v-3.75c0-1.582.773-3.125 3.258-3.125h2.523V8.203s-2.289-.39-4.476-.39c-4.57 0-7.555 2.769-7.555 7.78V20h-5.078v5.781h5.078v13.977q1.531.241 3.125.242 1.595-.001 3.125-.242V25.78z"
})));
export default SvgFacebookColored;